// removed by extract-text-webpack-plugin
module.exports = {"logoColumn":"BrandSearchModal-logo-column","logoImage":"BrandSearchModal-logo-image","logoVersionTable":"BrandSearchModal-logo-version-table"};


//////////////////
// WEBPACK FOOTER
// ./src/BrandSearchModal.css
// module id = 206
// module chunks = 0